import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactHtmlParser from 'react-html-parser';
import Loader from "../../component/loader";

function Writeup() {
  const [writeupData, setWriteupData] = useState();
  const [loader, setLoader] = useState(false);

  const writeupFetch = async () => {
    setLoader(true);
    try {
      const response = await axios.get(`/user/setting/sellerWriteup/view`);
      if (response.data) {
        setWriteupData(response.data.data.desc);
      }
    } catch (errors) {
      console.log('writeup data errors', errors);
    } finally {
      setLoader(false);
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    writeupFetch();
  }, []);

  return (
    <div className="responsive-xs responsive-sm">
      {loader ? (
        <Loader />
      ) : (
        <div className="card p-4">
          <h4 className="mb-4">Seller Guide</h4>
          <div>
            {ReactHtmlParser(writeupData && writeupData)}
          </div>
        </div>
      )}
    </div>
  );
}

export default Writeup;
